// Account-share landing — token in the URL IS the key (account-sharing S3).
// Auto-join on open, no sign-in wall: the visitor becomes a MUTUAL partner —
// both portfolios become visible to both. Guests keep the connection when
// they upgrade their anonymous session in place (uid-preserving link, so the
// membership survives). Revoked/invalid links show the dead state; already
// linked accounts go straight to the dashboard.
import { getAccountShareLink, getAccountShare, joinAccountShare } from '../lib/firestore.js';
import { isGuest } from '../lib/firebase.js';
import { renderHeaderIdentity, escapeHtml } from './parts.js';

export function renderAccountShare(el, { user, params, navigate }) {
  const token = params[0];
  el.innerHTML = `
    <div class="app-header">
      <a class="brand" href="#/map">Property Source</a>
      <nav><a href="#/map">Map</a></nav>
      <div id="header-who"></div>
    </div>
    <main>
      <div class="card" id="join-card"><div class="muted">Loading…</div></div>
    </main>`;
  renderHeaderIdentity(el.querySelector('#header-who'), { user, navigate });
  const cardEl = el.querySelector('#join-card');

  if (!token) {
    cardEl.innerHTML = '<div class="empty">Missing share link.</div>';
    return;
  }

  let started = false;

  async function run() {
    if (started) return;
    started = true;
    let link = null;
    try {
      link = await getAccountShareLink(token);
    } catch (e) {
      console.warn('account share link read failed', e);
    }
    if (!link || link.active !== true) {
      cardEl.innerHTML = '<div class="empty">This share link is invalid or was revoked.</div>';
      return;
    }
    const ownerName = link.owner_name || 'another account';
    if (!user) {
      // Fully signed-out visitor (no anonymous session) — sign in first.
      cardEl.innerHTML = `
        <div class="editor-badge">Connect your portfolio</div>
        <h1>${escapeHtml(ownerName)} is sharing their portfolio with you</h1>
        <p class="muted">Connecting is mutual — you'll see each other's properties, past and future.</p>
        <a class="btn" href="#/login">Sign in to connect</a>`;
      return;
    }
    let acc = null;
    try {
      acc = await getAccountShare(link.owner_uid);
    } catch (e) {
      console.warn('owner account share read failed', e);
    }
    if (!acc || acc.active !== true) {
      cardEl.innerHTML = '<div class="empty">This portfolio is no longer being shared.</div>';
      return;
    }
    if ((acc.member_uids || []).includes(user.uid)) {
      // Already linked — straight to the dashboard (plan edge case).
      navigate('#/dashboard');
      return;
    }
    try {
      await joinAccountShare(token, {
        uid: user.uid,
        displayName: user.displayName || user.email || 'Guest',
      });
    } catch (e) {
      console.warn('account share join failed', e);
      cardEl.innerHTML = '<div class="empty">Could not connect — the link may have been revoked.</div>';
      return;
    }
    cardEl.innerHTML = `
      <div class="editor-badge">You're connected ✓</div>
      <h1>Connected to ${escapeHtml(ownerName)}'s portfolio</h1>
      <p class="muted">You can now see each other's properties — sharing works both ways, and either side can stop at any time.</p>
      ${isGuest(user) ? '<p class="muted">Connected as guest — <a href="#/login">sign in to keep this connection</a>.</p>' : ''}
      <a class="btn" href="#/dashboard">View your dashboard</a>`;
  }

  run();
}
